export default "__VITE_ASSET__DDEwIYHr__"